const ProductAPI = {
    async fetch(handle) {
        const response = await fetch(`/products/${handle}.js`);
        const json = await response.json();
        return json;
    }
}

const CartAPI = {
    ADD_URL: '/cart/add.js',
    UPDATE_URL: '/cart/update.js',
    CART_URL: '/cart.js',

    async get () {
        const response = await fetch(this.CART_URL);
        const json = await response.json();
        return json;
    },

    async add (id, quantity) {
        const response = await fetch(this.ADD_URL, {
            method: 'POST',
            body: JSON.stringify({
                id: id,
                quantity: quantity,
                properties: {
                    '_gwp_surprise': 'yes'
                }
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const json = await response.json();
        // this.refresh();
        return json;
    },

    async update (id, quantity) {
        let updates = {};
        updates[`${id}`] = quantity;

        const response = await fetch(this.UPDATE_URL, {
            body: JSON.stringify({updates: updates}),
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
        });
        const json = await response.json();
        // this.refresh();
        return json;
    }
}

const RecordsAPI = {
    URL: 'https://api.sheety.co/1272066cc614dc187f9a37d977c4c42f/zoechiccoBfcmSurpriseGift/sheet1',

    async find (email) {
        const url = email ? `${this.URL}?filter[email]=${email}` : this.URL;
        const response = await fetch(url);
        const json = await response.json();
        return json.sheet1;
    },

    async add (email) {
        const record = {
            sheet1: {
                email: email,
                gwp: 1,
            }
        }
        const sheet1 = await this.find(email);

        if (sheet1?.length > 0) {
            return sheet1;
        }

        const response = await fetch(this.URL, {
            method: 'POST',
            body: JSON.stringify(record),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const json = await response.json();
        return json.sheet1;
    }
}

const CustomerSurpriseGift = {
    product: ProductAPI,
    cart: CartAPI,
    records: RecordsAPI,
    email: window._gs?.email,
    config: window._gs?.config || {},
    product_id: null,
    productInCart: false,

    init() {
        this.updateCookie();
        this.initSurpriseGift().then(() => {
            console.log('Surprise GWP initialized!');
        });
    },

    async initSurpriseGift() {
        const _this = this;
        let shouldDeleteProduct = false;
        const _validateGiftProductInCart = await _this._validateGiftProductInCart();
        const _canAddGift = await this.canAddGift();

        // if (_canAddGift && this._validateEmailExists() && !_validateGiftProductInCart) {
        if (_canAddGift && !_validateGiftProductInCart) {
            // Check if record exists as a nested condition to avoid unnecessary API calls
            // const _validateGiftRecordExists = await this._validateGiftRecordExists();
            // if (!_validateGiftRecordExists) {
            _this.cart.add(_this.product_id, 1).then(() => {
                console.log('Added surprise gift to cart');
                _this._refresh();
            });
            // } else {
            //     shouldDeleteProduct = true;
            // }
        }

        if (_validateGiftProductInCart && (shouldDeleteProduct || !_canAddGift)) {
            _this.cart.update(_this.product_id, 0).then(() => {
                console.log('Removed surprise gift from cart');
                _this._refresh();
            });
        }

        // if (Shopify?.Checkout?.page === 'thank_you' && _validateGiftProductInCart) {
        //     localStorage.setItem('_zoechicco_gwp_surprise_exhausted_new', true);
        //     // this.records.add(this.email);
        // }

        // Add check for more than 1 gift in cart
    },

    async canAddGift() {
        const _validateGiftProduct = await this._validateGiftProduct();
        const _validateEmptyCart = await this._validateEmptyCart();

        return this._validateIsEnabled() &&
            this._validateCookie() &&
            this._validateDateInterval() &&
            !this._validateProductExhausted() &&
            !_validateEmptyCart &&
            _validateGiftProduct;
    },


    // bindEvents() {
    //     const _this = this;
    //     document.addEventListener('DOMContentLoaded', () => {
    //     });
    // },

    updateCookie() {
        if(this.config.url_parameter && location.href.includes(this.config.url_parameter)) {
            localStorage.setItem('_zoechicco_gwp_surprise', true);
        }
    },

    _validateEmailExists() {
        return typeof this.email !== 'undefined';
    },

    async _validateEmptyCart() {
        const cart = await this.cart.get();
        return cart?.items_subtotal_price === 0;
    },

    async _validateGiftProduct() {
        try {
            const product = await this.product.fetch(this.config.product_id);
            if (product?.variants?.length > 0) {
                const variant = product.variants[0];
                if (variant.available) {
                    this.product_id = variant.id;
                    return true;
                }
            }
        } catch (error) {
            console.log(error);
        }
        return false;
    },

    _validateProductExhausted() {
        const productExhausted = localStorage.getItem('_zoechicco_gwp_surprise_exhausted_new');
        if (productExhausted) {
            return true;
        }
        return false;
    },

    async _validateGiftRecordExists() {
        const email = this.email;
        if (!email) {
            return false;
        }
        const findRecord = await this.records.find(email);
        if (findRecord?.length > 0) {
            localStorage.setItem('_zoechicco_gwp_surprise_exhausted', true);
        }

        return findRecord?.length > 0;
    },

    async _validateGiftProductInCart() {
        const cart = await this.cart.get();
        const gift = cart.items.find(item => item.properties?._gwp_surprise === 'yes');
        if (gift) {
            this.product_id = gift.variant_id;
            this.productInCart = true;
        }
        return gift !== undefined;
    },

    _validateIsEnabled() {
        return this.config?.is_enabled;
    },

    _validateCookie() {
        const cookie = localStorage.getItem('_zoechicco_gwp_surprise');
        return cookie === 'true';
    },

    _validateDateInterval() {
        return this._isValidStartDate() &&
            this._isValidEndDate();
    },

    _isValidStartDate() {
        let currentDate = Date.now(),
            start_date = this.config?.start_date,
            start_time = this.config?.start_time,
            promoStartDate = Date.parse(`${start_date.trim()} ${start_time.trim()}`);

        if (!start_date.trim()) {
            return true;
        }

        return !isNaN(promoStartDate) && currentDate >= promoStartDate;
    },

    _isValidEndDate() {
        let currentDate = Date.now(),
            end_date = this.config?.end_date,
            end_time = this.config?.end_time,
            promoEndDate = Date.parse(`${end_date.trim()} ${end_time.trim()}`);

        if (!end_date.trim()) {
            return true;
        }

        return isNaN(promoEndDate) || currentDate <= promoEndDate;
    },

    _refresh () {
        if(Shopify.Checkout || document.querySelector('.template-cart')) {
            window.location.reload();
        }
        else {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
            }));
        }
    }
}

// if (Shopify.Checkout) {
//     (function($) {
//         $(document).on("page:load page:change", function() {
//             CustomerSurpriseGift.init();
//         });
//     })(Checkout.$);
// }
CustomerSurpriseGift.init();